import { CustomizableListMenu } from '@openx/components-core/lib/CustomizableListMenu/CustomizableListMenu.tsx';
import type { DealInsightsGeneralStatsApi } from '@openx/types/dealInsights.ts';
import { type JSX, useMemo } from 'react';
import type { StatsPanelConfig } from '../types.ts';

export interface StatsPanelSettingsProps {
  config: StatsPanelConfig[];
  onConfigChange: (config: StatsPanelConfig[]) => void;
  panelLabels: Record<keyof Omit<DealInsightsGeneralStatsApi, 'previous_period_calculated'>, string>;
}

export const StatsPanelSettings = ({ config, onConfigChange, panelLabels }: StatsPanelSettingsProps): JSX.Element => {
  const configWithId = useMemo(
    () =>
      config.map(item => ({
        id: item.key,
        ...item,
        label: panelLabels[item.key] || item.key,
      })),
    [config, panelLabels]
  );

  const handleItemsChange = (newItems: typeof configWithId): void => {
    const newConfig = newItems.map(item => ({
      key: item.key,
      hide: item.hide,
    }));
    onConfigChange(newConfig);
  };

  return (
    <CustomizableListMenu
      items={configWithId}
      onItemsChange={handleItemsChange}
      getItemLabel={item => item.label || item.key}
      testIdPrefix="stats-panel"
    />
  );
};
